import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, Inject } from "@angular/core";
import { AppInsightsService } from "../shared/services/appinsights/appinsights.service";
import { AppConfig } from "../../assets/config/appconfig";

@Component({
  selector: "sampleBillModal",
  template: `
    <div class="sample-bill-modal-header-row">
      <span class="sample-bill-modal-title">
        <app-locale
          localeKey="SAMPLE_BILL_MODAL_TITLE_LABEL"
          localeView="CUSTOMER"
        ></app-locale>
      </span>
      <div class="form-btn-group-right">
        <span class="form-close-link" mat-button (click)="onClose()">
          <span class="icon icon-close"></span>
        </span>
      </div>
    </div>
    <div>
      <div mat-dialog-content class="sample-bill-mat-dialog-content">
        <div *ngIf="provider === 'SCE'" class="fill">
          <img src="{{ 'assets/img/' + provider + '/SampleBill_' + lang + '.jpg' }}" />
        </div>
        <div *ngIf="provider === 'PGE' || provider === 'SDGE'" class="fill">
          <img src="{{ 'assets/img/' + provider + '/SampleBill_' + lang + '.png' }}" />
        </div>
      </div>
    </div>
  `,
})
export class SampleBillModal {
  lang: string;
  provider: string;
  ccaName: string;
  imgPath: string;
  constructor(
    public dialogRef: MatDialogRef<SampleBillModal>,
    private _appConfig: AppConfig,
    private appInsightsService: AppInsightsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.lang = data.lang;
    this.provider = data.provider;
    this.ccaName = _appConfig.settings.ccaName;
    this.appInsightsService.logPageView("SampleBillComponent");
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
